module.exports = __webpack_public_path__ + "img/pic3.dae9523b.jpeg";